import { render } from "./FinalTracks.vue?vue&type=template&id=38888b0b"
const script = {}

import "./FinalTracks.vue?vue&type=style&index=0&id=38888b0b&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__